import Input from 'components/v2/Input/Input';
import { useField } from 'formik';

const RoomName = () => {
  const [inputProps, { error, touched }] = useField('name');
  return <Input inputProps={inputProps} label="Name of Room" error={touched ? error : ''} />;
};

export default RoomName;
